var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "registerBox" }, [
        _c("div", { staticClass: "rightBox" }, [
          _c(
            "div",
            { staticClass: "Tips", staticStyle: { "margin-bottom": "4px" } },
            [_vm._v("必填信息")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "Requirement",
              staticStyle: { "border-top": "1px solid #e0e0e0" }
            },
            [
              _c("div", { staticClass: "letRe fl" }, [_vm._v("卡号")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.vipno,
                    expression: "vipno"
                  }
                ],
                staticClass: "rigRe fr",
                attrs: {
                  type: "number",
                  placeholder: "请输入卡号",
                  pattern: "[0-9]*"
                },
                domProps: { value: _vm.vipno },
                on: {
                  focus: _vm.focus,
                  blur: _vm.blur,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.vipno = $event.target.value
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "Requirement" }, [
            _c("div", { staticClass: "letRe fl" }, [_vm._v("姓名")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name"
                }
              ],
              staticClass: "rigRe fr",
              attrs: { type: "text", placeholder: "请输入姓名" },
              domProps: { value: _vm.name },
              on: {
                focus: _vm.focus,
                blur: _vm.blur,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Requirement" }, [
            _c("div", { staticClass: "letRe fl" }, [_vm._v("电话")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.tel,
                  expression: "tel"
                }
              ],
              staticClass: "rigRe fr",
              attrs: {
                type: "number",
                placeholder: "请输入电话号码",
                pattern: "[0-9]*"
              },
              domProps: { value: _vm.tel },
              on: {
                focus: _vm.focus,
                blur: _vm.blur,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.tel = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "vcodeSty",
                class: _vm.itemFlase ? "" : "vcodeStyFa",
                on: { click: _vm.clickVcode }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.itemFlase ? "获取验证码" : _vm.idx) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Requirement" }, [
            _c("div", { staticClass: "letRe fl" }, [_vm._v("验证码")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.vcode,
                  expression: "vcode"
                }
              ],
              staticClass: "rigRe fr",
              attrs: {
                type: "number",
                placeholder: "请输入验证码",
                pattern: "\\d*"
              },
              domProps: { value: _vm.vcode },
              on: {
                focus: _vm.focus,
                blur: _vm.blur,
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.vcode = $event.target.value
                  },
                  function($event) {
                    return _vm.handleChange($event)
                  }
                ]
              }
            })
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "Determine",
              on: {
                click: function($event) {
                  return _vm.clickApply()
                }
              }
            },
            [_vm._v("申请绑定")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.toast,
              expression: "toast"
            }
          ],
          staticClass: "toast"
        },
        [_vm._v(_vm._s(_vm.toastText))]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Tips" }, [
      _c("div", { staticClass: "Tips_lo fl" }, [_vm._v("i")]),
      _vm._v(" "),
      _c("div", { staticClass: "Tips_text fl" }, [
        _vm._v(
          "\n          卡号、姓名、电话要与办卡时一致才能通过验证\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-485cd0d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485cd0d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/BindingMember/index.vue
// module id = null
// module chunks = 